<template lang="pug">
v-flex(xs12)
  div.expande-horizontal.centraliza.wrap
    v-flex(xs12)
      div.expande-horizontal
        CardMethod(v-if="get_checkout.method === 'card'")
        PixMethod(v-if="get_checkout.method === 'pix'")
</template>

<script>
import { mapGetters } from "vuex";
import CardMethod from "./methods/Card.vue";
import PixMethod from "./methods/Pix.vue";

export default {
  components: {
    CardMethod,
    PixMethod
  },
  computed: {
    ...mapGetters(["get_checkout"])
  }
};
</script>
